import type { Block, Fragment } from '@gitbook/slate';

import { isBlockEmpty } from './isBlockEmpty';

/**
 * Test if a fragment only contains empty blocks.
 */
export function isFragmentEmpty(fragment: Fragment): boolean {
    if (fragment.nodes.size === 0) {
        return true;
    }

    return fragment.nodes.every((node) => {
        if (node.object !== 'block') {
            return false;
        }

        return isBlockEmpty(node as Block, { trim: true });
    });
}
